module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', [_c('v-layout', {
    staticClass: "arrow-up py-2",
    attrs: {
      "row": "",
      "align-center": "",
      "justify-center": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit('prev')
      }
    }
  }, [_c('v-icon', [_vm._v("keyboard_arrow_up")])], 1), _vm._v(" "), (_vm.err) ? _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-alert', {
    attrs: {
      "type": "error",
      "value": true
    }
  }, [_vm._v(_vm._s(_vm.err))])], 1) : _vm._e(), _vm._v(" "), _c('v-layout', {
    staticClass: "px-2",
    attrs: {
      "row": "",
      "wrap": "",
      "align-start": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "px-3": "",
      "pb-1": ""
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$lang.labels.created) + ": "), _c('span', {
    staticClass: "mx-2"
  }, [_vm._v(_vm._s(_vm.formatDate(_vm.config.createdOn)))])])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "px-3": "",
      "pb-1": ""
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$lang.header.synched) + ":\n          "), (_vm.config.synchedOn) ? _c('span', {
    staticClass: "mx-2"
  }, [_vm._v(_vm._s(_vm.formatDate(_vm.config.synchedOn)))]) : _c('span', {
    staticClass: "mx-2 no-data"
  }, [_vm._v(_vm._s(_vm.$lang.errors.noData))])])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "px-3": "",
      "pb-1": ""
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$lang.labels.companyName) + ": "), _c('span', {
    staticClass: "mx-2"
  }, [_vm._v(_vm._s(_vm.config.companyName))])])]), _vm._v(" "), (_vm.config.refreshCorporation) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "px-3": "",
      "pb-1": ""
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$lang.labels.corporation) + ": "), _c('span', {
    staticClass: "mx-2"
  }, [_vm._v(_vm._s(_vm.config.refreshCorporation))])])]) : _vm._e(), _vm._v(" "), (this.type === 'moon') ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "px-3": "",
      "pb-1": ""
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$lang.header.moonInstName) + ": "), _c('span', {
    staticClass: "mx-2"
  }, [_vm._v(_vm._s(_vm.config.moonInsatanceName))])])]) : _vm._e(), _vm._v(" "), (this.type === 'planet') ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "px-3": "",
      "pb-1": ""
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$lang.labels.planetInstName) + ": "), _c('span', {
    staticClass: "mx-2"
  }, [_vm._v(_vm._s(_vm.config.planetInstanceName))])])]) : _vm._e(), _vm._v(" "), (_vm.config.status) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "px-3": "",
      "pb-1": ""
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$lang.labels.status) + ": "), _c('span', {
    staticClass: "mx-2"
  }, [_vm._v(_vm._s(_vm.config.status))])])]) : _vm._e(), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "px-3": "",
      "pb-1": ""
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$lang.labels.companyDataUpdated) + ":\n          "), (_vm.config.refreshCompanyData) ? _c('span', {
    staticClass: "mx-2"
  }, [_vm._v(_vm._s(_vm.config.refreshCompanyData === true ? 'Yes' : 'No'))]) : _c('span', {
    staticClass: "mx-2 no-data"
  }, [_vm._v(_vm._s(_vm.$lang.errors.noData))])])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "px-3": "",
      "pb-1": ""
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$lang.header.accounts) + ":\n          "), (_vm.config.refreshAccounts) ? _c('ul', _vm._l((_vm.config.refreshAccounts), function(account, index) {
    return _c('li', {
      key: index
    }, [_vm._v(_vm._s(account))])
  }), 0) : _c('span', {
    staticClass: "mx-2 no-data"
  }, [_vm._v(_vm._s(_vm.$lang.errors.noData))])])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "px-3": "",
      "pb-1": ""
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$lang.header.printers) + ":\n          "), (_vm.config.refreshPrinters) ? _c('ul', _vm._l((_vm.config.refreshPrinters), function(printer, index) {
    return _c('li', {
      key: index
    }, [_vm._v(_vm._s(printer))])
  }), 0) : _c('span', {
    staticClass: "mx-2 no-data"
  }, [_vm._v(_vm._s(_vm.$lang.errors.noData))])])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "px-3": "",
      "pb-1": ""
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$lang.header.printTemplates) + ":\n          "), (_vm.config.refreshPrintTemplates) ? _c('ul', _vm._l((_vm.config.refreshPrintTemplates), function(template, index) {
    return _c('li', {
      key: index
    }, [_vm._v(_vm._s(template))])
  }), 0) : _c('span', {
    staticClass: "mx-2 no-data"
  }, [_vm._v(_vm._s(_vm.$lang.errors.noData))])])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "px-3": "",
      "pb-1": ""
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$lang.header.printServers) + ":\n          "), (_vm.config.refreshPrintServers) ? _c('ul', _vm._l((_vm.config.refreshPrintServers), function(server, index) {
    return _c('li', {
      key: index
    }, [_vm._v(_vm._s(server))])
  }), 0) : _c('span', {
    staticClass: "mx-2 no-data"
  }, [_vm._v(_vm._s(_vm.$lang.errors.noData))])])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "px-3": "",
      "pb-1": ""
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$lang.header.catalogs) + ":\n          "), (_vm.config.refreshCatalogs) ? _c('ul', _vm._l((_vm.config.refreshCatalogs), function(catalog, index) {
    return _c('li', {
      key: index
    }, [_vm._v(_vm._s(catalog))])
  }), 0) : (_vm.config.refreshCatalogData) ? _c('ul', _vm._l((_vm.config.refreshCatalogData), function(catalog, index) {
    return _c('li', {
      key: index
    }, [_vm._v(_vm._s(catalog))])
  }), 0) : _c('span', {
    staticClass: "mx-2 no-data"
  }, [_vm._v(_vm._s(_vm.$lang.errors.noData))])])]), _vm._v(" "), (_vm.config.tables) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "px-3": "",
      "pb-1": ""
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$lang.header.tables) + ":\n          "), (_vm.config.tables) ? _c('ul', _vm._l((_vm.config.tables), function(tables, index) {
    return _c('li', {
      key: index
    }, [_vm._v(_vm._s(tables))])
  }), 0) : _c('span', {
    staticClass: "mx-2 no-data"
  }, [_vm._v(_vm._s(_vm.$lang.errors.noData))])])]) : _vm._e(), _vm._v(" "), (_vm.config.tableCategories) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "px-3": "",
      "pb-1": ""
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$lang.header.tableCategories) + ":\n          "), (_vm.config.tableCategories) ? _c('ul', _vm._l((_vm.config.tableCategories), function(tableCat, index) {
    return _c('li', {
      key: index
    }, [_vm._v(_vm._s(tableCat))])
  }), 0) : _c('span', {
    staticClass: "mx-2 no-data"
  }, [_vm._v(_vm._s(_vm.$lang.errors.noData))])])]) : _vm._e(), _vm._v(" "), (_vm.config.refreshTables) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "px-3": "",
      "pb-1": ""
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$lang.header.tables) + ":\n        "), (_vm.config.refreshTables) ? _c('ul', _vm._l((_vm.config.refreshTables), function(tables, index) {
    return _c('li', {
      key: index
    }, [_vm._v(_vm._s(tables))])
  }), 0) : _c('span', {
    staticClass: "mx-2 no-data"
  }, [_vm._v(_vm._s(_vm.$lang.errors.noData))])])]) : _vm._e(), _vm._v(" "), (_vm.config.refreshTableCategories) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "px-3": "",
      "pb-1": ""
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$lang.header.tableCategories) + ":\n        "), (_vm.config.refreshTableCategories) ? _c('ul', _vm._l((_vm.config.refreshTableCategories), function(tableCat, index) {
    return _c('li', {
      key: index
    }, [_vm._v(_vm._s(tableCat))])
  }), 0) : _c('span', {
    staticClass: "mx-2 no-data"
  }, [_vm._v(_vm._s(_vm.$lang.errors.noData))])])]) : _vm._e(), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "px-3": "",
      "pb-1": ""
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$lang.header.callerIdServers) + ":\n          "), (_vm.config.refreshCallerIdServers) ? _c('ul', _vm._l((_vm.config.refreshCallerIdServers), function(callerID, index) {
    return _c('li', {
      key: index
    }, [_vm._v(_vm._s(callerID))])
  }), 0) : _c('span', {
    staticClass: "mx-2 no-data"
  }, [_vm._v(_vm._s(_vm.$lang.errors.noData))])])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "px-3": "",
      "pb-1": ""
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$lang.header.webShopResource) + ":\n          "), (_vm.config.refreshWebShopResourceNames) ? _c('ul', _vm._l((_vm.config.refreshWebShopResourceNames), function(tableCat, index) {
    return _c('li', {
      key: index
    }, [_vm._v(_vm._s(tableCat))])
  }), 0) : _c('span', {
    staticClass: "mx-2 no-data"
  }, [_vm._v(_vm._s(_vm.$lang.errors.noData))])])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "px-3": "",
      "pb-1": ""
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$lang.labels.langMapforPrintCat) + ":\n          "), _c('br'), _vm._v(" "), (_vm.config.refreshPrinterCategoryLanguageMappings) ? _c('span', {
    staticClass: "mx-2"
  }, [_vm._v(_vm._s(_vm.config.refreshPrinterCategoryLanguageMappings === true ? 'Yes' : 'No'))]) : _c('span', {
    staticClass: "mx-2 no-data"
  }, [_vm._v(_vm._s(_vm.$lang.errors.noData))])])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "px-3": "",
      "pb-1": ""
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$lang.labels.discountRules) + ":\n          "), (_vm.config.refreshDiscountRules) ? _c('span', {
    staticClass: "mx-2"
  }, [_vm._v(_vm._s(_vm.config.refreshDiscountRules === true ? 'Yes' : 'No'))]) : _c('span', {
    staticClass: "mx-2 no-data"
  }, [_vm._v(_vm._s(_vm.$lang.errors.noData))])])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "px-3": "",
      "pb-1": ""
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$lang.labels.discountRuleNames) + ":\n          "), (_vm.config.refreshDiscountRuleNames) ? _vm._l((_vm.config.refreshDiscountRuleNames), function(ruleName, index) {
    return _c('ul', {
      key: index
    }, [_c('li', [_vm._v(_vm._s(ruleName))])])
  }) : _c('span', {
    staticClass: "mx-2 no-data"
  }, [_vm._v(_vm._s(_vm.$lang.errors.noData))])], 2)]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "px-3": "",
      "pb-1": ""
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$lang.labels.depReceipts) + ":\n          "), (_vm.config.depReceipts) ? _vm._l((_vm.config.depReceipts), function(dep, index) {
    return _c('ul', {
      key: index
    }, [_c('li', [_vm._v(_vm._s(dep))])])
  }) : _c('span', {
    staticClass: "mx-2 no-data"
  }, [_vm._v(_vm._s(_vm.$lang.errors.noData))])], 2)]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "px-3": "",
      "pb-1": ""
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$lang.labels.paymentTerminals) + ":\n          "), (_vm.config.refreshPaymentTerminals) ? _vm._l((_vm.config.refreshPaymentTerminals), function(terminal, index) {
    return _c('ul', {
      key: index
    }, [_c('li', [_vm._v(_vm._s(terminal))])])
  }) : _c('span', {
    staticClass: "mx-2 no-data"
  }, [_vm._v(_vm._s(_vm.$lang.errors.noData))])], 2)]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "px-3": "",
      "pb-1": ""
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$lang.labels.paymentServers) + ":\n          "), (_vm.config.refreshPaymentServers) ? _vm._l((_vm.config.refreshPaymentServers), function(server, index) {
    return _c('ul', {
      key: index
    }, [_c('li', [_vm._v(_vm._s(server))])])
  }) : _c('span', {
    staticClass: "mx-2 no-data"
  }, [_vm._v(_vm._s(_vm.$lang.errors.noData))])], 2)])], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "close-btn",
    attrs: {
      "fab": "",
      "small": "",
      "flat": "",
      "absolute": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "arrow-down py-2",
    attrs: {
      "row": "",
      "align-center": "",
      "justify-center": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit('next')
      }
    }
  }, [_c('v-icon', [_vm._v("keyboard_arrow_down")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-17e5f1c6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/configUpdates/ConfigUpdateView.vue
// module id = 569
// module chunks = 27